import {
  ICreditLimitResponse,
  ICreditPaymentPlansResponse,
  ICreditUserStatusResponse,
} from "interfaces/credit.interface";
import axios from "../../interceptors/axiosInterceptor";
import {
  GET_CREDIT_PAYMENT_PLANS,
  GET_CREDIT_USER,
  GET_USER_CREDIT_LIMIT,
} from "../../config/Url";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";

export const fetchUserCreditLimitCall = (userId: string) =>
  new Promise<ICreditLimitResponse>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = {
      userId: userId,
    };
    axios
      .get(GET_USER_CREDIT_LIMIT, requestConfig)
      .then((response) => {
        if (!response) reject({ errors: "Error fetching User Credit Limit" });
        resolve(response.data && response.data.body);
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const fetchCreditUserCall = (userId: string) =>
  new Promise<ICreditUserStatusResponse>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    let url = GET_CREDIT_USER.replace("{userId}", userId);
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          resolve(response.data && response.data.body);
        } else {
          resolve({ status: "NOT_STARTED" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        // reject(errorPayload);
        resolve({ status: "NOT_STARTED" });
      });
  });

export const fetchCreditPaymentPlansCall = (
  channelType: string,
  userId: string
) =>
  new Promise<ICreditPaymentPlansResponse[]>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = {
      channelType: channelType,
      userId,
    };
    axios
      .get(GET_CREDIT_PAYMENT_PLANS, requestConfig)
      .then((response) => {
        if (!response)
          reject({ errors: "Error fetching Credit Payment Plans" });
        resolve(response.data && response.data.body);
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });
